export const AI_GENERATED_TITLES_PER_DAY = 200
export const AI_GENERATED_CHANGELOGS_PER_DAY = 20

export const issueStatusOrderRecord = {
	started: 1,
	unstarted: 2,
	triage: 3,
	completed: 4,
	backlog: 5,
	canceled: 6,
	duplicate: 7,
	closed: 8,
}

export const projectStatusOrderRecord = {
	started: 1,
	planned: 2,
	paused: 3,
	completed: 4,
	backlog: 5,
	canceled: 6,
	closed: 6,
}

export const projectSelectStatusOrder = {
	backlog: 1,
	planned: 2,
	started: 3,
	completed: 4,
	canceled: 5,
}

//https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
export const EMAIL_MAXIMUM_LENGTH = 254
export const EMAIL_MAXIMUM_LENGTH_ERROR_MESSAGE =
	"Please enter a valid email address (maximum 254 characters)."

export const WORKSPACE_NAME_MAXIMUM_LENGTH = 120
export const INVITE_NAME_MAXIMUM_LENGTH = 128

export const SENDER_NAME_MAX_LENGTH = 255
export const SENDER_NAME_MAX_LENGTH_ERROR_MESSAGE =
	"Sender name must be at most 255 characters."

export const SUBJECT_MAX_LENGTH = 998
export const SUBJECT_MAX_LENGTH_ERROR_MESSAGE =
	"Subject must be at most 998 characters."

export const PAGE_FEEDBACK_MAX_LENGTH = 2000

export const PAGE_FEEDBACK_PAGES = ["reporting"] as const
export type PageFeedbackPage = (typeof PAGE_FEEDBACK_PAGES)[number]

export const PAGE_FEEDBACK_LABELS: Record<PageFeedbackPage, string> = {
	reporting: "Reporting",
}
